<script lang="ts">
  import Dialog from "./Dialog.svelte";
  import { dialogs } from "./dialogs.svelte";
</script>

<!-- The web's alert() and confirm() dialogs. -->
{#each dialogs.open as request (request)}
  <Dialog
    open
    title={request.title}
    closable={!request.busy}
    oncancel={(event: Event) => {
      // Escape can't close it while its action runs.
      if (request.busy) event.preventDefault();
    }}
    onclose={() => request.settle(false)}
    data-testid="{request.kind}-dialog"
  >
    <p>{request.message}</p>
    {#snippet actions()}
      {#if request.kind === "confirm"}
        <button
          class="btn info"
          disabled={request.busy}
          onclick={() => request.settle(false)}
          data-testid="cancel-btn">{request.cancel}</button
        >
      {/if}
      <button
        class={request.okClass}
        disabled={request.busy}
        onclick={() => request.settle(true)}
        data-testid="ok-btn"
      >
        {#if request.busy}
          <span class="loading loading-spinner loading-md"></span>
        {:else}
          {request.ok}
        {/if}
      </button>
    {/snippet}
  </Dialog>
{/each}
